import { clsx, type ClassValue } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  // Keep this simple: clsx handles conditional + merged class lists.
  // We deliberately avoid tailwind-merge here to prevent missing vendor chunk issues in Next dev.
  return clsx(inputs)
}

// Canonical price display lives in lib/format-utils (owner ruling 07/25/2026:
// whole dollars drop ".00", real cents render exactly). Re-exported here so
// existing `import { formatPrice } from '@/lib/utils'` call sites inherit it.
export { formatPrice } from './format-utils'

// NO Supabase re-export here. `cn` is imported by nearly every client
// component, so anything this module re-exports rides into the browser bundle
// with it. Re-exporting the SERVICE-ROLE admin factory "for convenience" put
// `@supabase/supabase-js` in the first-load graph of all 215 routes — measured
// 08/29/2026 at +234.5 kB per route against origin/main, on a programme whose
// whole purpose is Core Web Vitals recovery.
//
// It was also dead: zero call sites imported getSupabaseAdmin from '@/lib/utils'.
// Import it from '@/lib/supabaseAdmin' directly — a barrel must never mix a
// client-safe helper with a server-only database client.
